import React, { PropsWithChildren } from "react";

function DirectionsIconWhite(props: PropsWithChildren<any>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="19"
      fill="none"
      viewBox="0 0 14 19"
    >
      <path
        fill="#fff"
        d="M6.75 3.625C4.887 3.625 3.375 5.172 3.375 7a3.376 3.376 0 003.375 3.375c1.828 0 3.375-1.512 3.375-3.375 0-1.828-1.547-3.375-3.375-3.375zm0 5.625A2.221 2.221 0 014.5 7c0-1.23.984-2.25 2.25-2.25C7.98 4.75 9 5.77 9 7c0 1.266-1.02 2.25-2.25 2.25zm0-9A6.73 6.73 0 000 7c0 2.742.914 3.516 6.047 10.898a.821.821 0 001.371 0C12.551 10.516 13.5 9.742 13.5 7A6.752 6.752 0 006.75.25zm0 16.664C1.828 9.848 1.125 9.285 1.125 7c0-1.477.563-2.883 1.617-3.973 1.09-1.054 2.496-1.652 4.008-1.652 1.477 0 2.883.598 3.973 1.652 1.054 1.09 1.652 2.496 1.652 3.973 0 2.285-.738 2.848-5.625 9.914z"
      ></path>
    </svg>
  );
}

export default React.memo(DirectionsIconWhite);
